export default "__VITE_ASSET__01c23fb1__"